export const CHECKOUT_BREAK_POINT = 768;
export const QUICK_CHECKOUT_BREAK_POINT = 542;
export const PAYMENT_CONTENT_WIDTH = 983;
